<template>
  <div class="database-manage-container">
    <div style="color: #fff">{{ delId }}</div>
    <div
      class="create-database-container"
      :class="{ 'create-database-en': isEn }"
    >
      <div class="database-title title-1">{{ $t("message.xjsjk") }}</div>
      <div class="create-database">
        <el-form
          ref="form"
          class="sjk-form"
          :model="form"
          :label-width="isEn ? '110px' : '66px'"
        >
          <el-form-item :label="$t('message.dlfs')" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio class="sjk-radio" label="sqlserver">sqlserver</el-radio>
              <el-radio class="sjk-radio" label="mysql">mysql</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item :label="$t('message.qds')" prop="name">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.name"
            ></el-input>
          </el-form-item> -->

          <el-form-item :label="$t('message.server')" prop="host">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.host"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.port')" prop="port">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.port"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.username')" prop="username">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.username"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.psw')" prop="password">
            <el-input
              clearable
              show-password
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.password"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('message.database')" prop="databaseName">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.databaseName"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item :label="$t('message.parameter')" prop="name">
            <el-input
              clearable
              class="searchBar-input searchBar-input-zi"
              :class="{ 'searchBar-input-zi-en': isEn }"
              :placeholder="$t('message.pleaseEnter')"
              v-model="form.name"
            ></el-input>
          </el-form-item> -->
        </el-form>
        <div class="searchBarBtn searchBarBtn-database" :class="{'searchBarBtn-database-en': isEn}">
          <!-- <template v-if="form.id">
            <div class="resetBtn" @click="clearForm">
              <span>{{ $t("message.cancel") }}</span>
            </div>
          </template> -->

          <!-- <template v-else> -->
          <div class="resetBtn" @click="testHandle(form)">
            <span>{{ $t("message.testlink") }}</span>
          </div>
          <!-- </template> -->

          <div class="lookBtn" @click="confirm">
            <span>{{
              form.id ? $t("message.bj") : $t("message.xinjian")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="database-list-container">
      <div class="database-title title-2">{{ $t("message.dqsjklb") }}
        <!-- <div v-if="hasToken" class="plsc-btn plsc-btn-database" :class="{'plsc-btn-database-en': isEn}">{{ $t('message.sjkbf') }}</div> -->
      </div>
      <div class="database-list">
        <div class="database-blank"></div>
        <div class="list-main" style="position: relative">
          <el-table
            class="list-table list-table-database"
            ref="table"
            highlight-current-row
            :height="tableHeight"
            :data="lists"
            @row-click="handleCurrentTableChange"
          >
            <el-table-column
              show-overflow-tooltip
              prop="databaseName"
              :label="$t('message.sjkmc')"
            >
              <template slot-scope="scope">
                <span :class="{ 'is-act': isSelection(scope.row.id) }"
                  >{{ scope.row.databaseName
                  }}{{
                    isSelection(scope.row.id) ? `(${$t("message.dqxz")})` : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="type"
              :label="$t('message.sjklx')"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="host"
              :label="$t('message.sjkdz')"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="port"
              :label="$t('message.sjkdk')"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="type"
              :label="$t('message.sjkzt')"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.status == 2
                      ? 'danger'
                      : scope.row.status == 1
                      ? 'success'
                      : 'info'
                  "
                  effect="plain"
                  >{{
                    scope.row.status == 2
                      ? $t("message.yzsb")
                      : scope.row.status == 1
                      ? $t("message.yztg")
                      : $t("message.dyz")
                  }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column width="220" :label="$t('message.cz')">
              <template slot-scope="scope">
                <span class="edit" @click.stop="testHandle(scope.row)">{{
                  $t("message.testlink")
                }}</span>
                <span
                  class="edit"
                  :class="{ 'edit-disabled': scope.row.status != 1 }"
                  @click.stop="chooseDatabase(scope.row)"
                  >{{ $t("message.xz") }}</span
                >
                <!-- <el-popconfirm
                  :title="$t('message.plscqr3')"
                  :confirm-button-text="$t('message.confirm')"
                  :cancel-button-text="$t('message.cancel')"
                  @confirm="del(scope.row.id)"
                >
                  <span class="del" slot="reference" @click.stop>{{
                    $t("message.sc")
                  }}</span>
                </el-popconfirm> -->
                <span class="del" @click.stop="delComfirm(scope.row.id)">{{
                  $t("message.sc")
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="[5, 10, 20, 30, 40, 50]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div>
        <div class="database-blank"></div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/axios/request.js";
import myMixin from "@/mixins/myMixin.js";
import { EventBus } from "@/utils/eventBus.js";
import alertDialog from "@/components/alertDialog.vue";

export default {
  mixins: [myMixin],
  components: {
    alertDialog,
  },
  props: {
    databasePropsId: {
      type: null,
      default: -9999,
    },
    isApp: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    EventBus.$off("sureDel");
  },
  data() {
    return {
      tableHeight: 0,
      databaseId: null,
      form: {
        id: "",
        type: "sqlserver",
        databaseName: "",
        host: "",
        port: "",
        username: "",
        password: "",
      },
      page: {
        pageSize: 20,
        pageNum: 1,
      },
      totals: 0,
      lists: [],
      isSubmiting: false,
      delId: null,
    };
  },
  watch: {},
  computed: {
    isEn() {
      return this.$i18n.locale == "en";
    },
    hasToken () {
      return window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : null;
    }
  },
  beforeDestroy() {
    this.$store.commit("CHANGE_DATABASE_YUAN_ID", null);
    this.$store.commit("CHANGE_DATABASE_YUAN_NAME", null);
    this.$store.commit("CHANGE_DATABASE_TEMP_ID", null);
    this.$store.commit("CHANGE_DATABASE_TEMP_NAME", null);
    this.$store.commit("CHANGE_DATABASE_LOGIN_SHOW", false);
    EventBus.$off("sureDel");
    window.removeEventListener('resize', this.updateTableHeight);
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener('resize', this.updateTableHeight);
    this.databaseId = sessionStorage.getItem("databaseId");
    this.getData();
    EventBus.$on("sureDel", () => {
      if (this.delId) {
        this.del();
      }
    });
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const tableContainer = this.$el.querySelector('.list-main');
        this.tableHeight = tableContainer.offsetHeight;
      });
    },
    delComfirm(val) {
      this.delId = val;
      this.$store.commit("CHANGE_DELETE_DIALOG_SHOW", true);
    },
    chooseDatabase(val) {
      if (val.status != 1) {
        return;
      }
      if (this.$route.name == "login") {
        let obj = {
          databaseId: val.id,
          databaseName: val.databaseName,
        };
        EventBus.$emit("chooseDatabase", obj);
        this.$store.commit("CHANGE_DATABASE_SHOW", false);
      } else {
        let databaseId = window.sessionStorage.getItem("databaseId");
        let databaseName = window.sessionStorage.getItem("databaseName");
        this.$store.commit("CHANGE_DATABASE_YUAN_ID", databaseId);
        this.$store.commit("CHANGE_DATABASE_YUAN_NAME", databaseName);
        this.$store.commit("CHANGE_DATABASE_TEMP_ID", val.id);
        this.$store.commit("CHANGE_DATABASE_TEMP_NAME", val.databaseName);
        this.$store.commit("CHANGE_DATABASE_LOGIN_SHOW", true);
      }
    },
    clearForm() {
      this.form = {
        type: "sqlserver",
        databaseName: "",
        host: "",
        port: "",
        username: "",
        password: "",
        id: "",
      };
    },
    async testHandle(params) {
      if (!params.id) {
        return this.$message({
          message: this.$t("message.testErrMsg"),
          type: "warning",
        });
      }
      if (this.isSubmiting) {
        return;
      }
      this.isSubmiting = true;
      try {
        let res = await request.post(`/datasource/connect/${params.id}`);
        if (res.code == 200) {
          this.$store.commit("CHANGE_ALERT_TEXT", res.msg);
          this.$store.commit("CHANGE_ALERT_SHOW", true);
        } else if (res.code == 401) {
          this.$store.commit("CHANGE_ALERT_TEXT", res.msg);
          this.$store.commit("CHANGE_ALERT_SHOW", true);
          this.logot();
        }
        this.isSubmiting = false;
        this.getData();
        this.clearForm();
      } catch (error) {
        this.$store.commit("CHANGE_ALERT_TEXT", error);
        this.$store.commit("CHANGE_ALERT_SHOW", true);

        this.isSubmiting = false;
        this.getData();
        this.clearForm();
      }
    },
    async editVoid() {
      try {
        let res = await request.post("/datasource/edit", this.form);
        if (res.code == 200) {
          this.getData();
          this.clearForm();
        } else if (res.code == 401) {
          this.$message({
            message: res.msg || "错误",
            type: "warning",
          });
          this.logot();
        }
        this.isSubmiting = false;
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
        });
        this.isSubmiting = false;
      }
    },
    async submitVoid() {
      try {
        console.log(this.form);
        let res = await request.post("/datasource/add", this.form);
        if (res.code == 200) {
          this.getData();
          this.clearForm();
        } else if (res.code == 401) {
          this.$message({
            message: res.msg || "错误",
            type: "warning",
          });
          this.logot();
        }
        this.isSubmiting = false;
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
        });
        this.isSubmiting = false;
      }
    },
    confirm() {
      if (this.isSubmiting) {
        return;
      }
      this.isSubmiting = true;
      if (this.form.id) {
        this.editVoid();
      } else {
        this.submitVoid();
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData();
    },
    handleCurrentTableChange(row) {
      console.log(row);
      if (row.id === this.form.id) {
        this.clearForm();
        this.$refs.table.setCurrentRow();
      } else {
        this.form = { ...row };
      }
    },
    async del() {
      if (this.isSubmiting) {
        return;
      }
      this.isSubmiting = true;
      try {
        let res = await request.delete(`/datasource/del/${this.delId}`);
        if (res.code == 200) {
          // this.$message({
          //   message: res.msg || "成功",
          //   type: "success",
          // });
          if (this.delId === this.form.id) {
            this.clearForm();
          }
          this.$store.commit("CHANGE_ALERT_TEXT", res.msg);
          this.$store.commit("CHANGE_ALERT_SHOW", true);
          this.getData();
          this.isSubmiting = false;
          this.delId = null;
        } else if (res.code == 401) {
          this.$message({
            message: res.msg || "错误",
            type: "warning",
          });
          this.isSubmiting = false;
          this.delId = null;
          this.logot();
        }
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
        });
        this.isSubmiting = false;
        this.delId = null;
      }
    },
    async getData() {
      try {
        let res = await request.post("/datasource/list", this.page);
        console.log(res);
        if (res.code == 200) {
          this.totals = res.data.total;
          this.lists = res.data.list;
        } else if (res.code == 401) {
          this.totals = 0;
          this.lists = [];

          this.$message({
            message: res.msg || "错误",
            type: "warning",
          });
          this.logot();
        }
      } catch (error) {
        this.totals = 0;
        this.lists = [];
        this.$message({
          message: error,
          type: "warning",
        });
      }
    },
    isSelection(id) {
      if (this.isApp) {
        return id == window.sessionStorage.getItem('databaseId');
      } else {
        return id == this.databasePropsId;
      }
    }
  }
};
</script>
<style scoped>
.searchBar-input-zi {
  width: 220px !important;
}
.searchBar-input-zi-en {
  width: 190px !important;
}

.database-manage-container {
  box-sizing: border-box;
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 0 10px;
}
.create-database-container {
  margin-right: 30px;
  width: 400px;
  height: 660px;
  display: flex;
  flex-direction: column;
}
.database-list-container {
  flex: 1;
  height: 660px;
  display: flex;
  flex-direction: column;
}
.create-database-en {
  width: 400px;
}
.database-title {
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  line-height: 50px;
  background-color: #1c1c1c;
  padding-bottom: 10px;
}
.title-1 {
  text-align: left;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  padding-left: 30px;
  background-color: rgba(46, 46, 46, 1);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  font-size: 16px;
  color: #FFF;
  background-color: #393838;
}
.title-2 {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding-left: 30px;
  box-sizing: border-box;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  text-align: left;
  background-color: #393838;
  position: relative;
}
.create-database {
  flex: 1;
  box-sizing: border-box;
  padding-top: 54px;
  padding-left: 46px;
  background-color: rgba(46, 46, 46, 1);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

::v-deep .el-form-item__label {
  color: #cdcdcd;
}
::v-deep .el-radio__input + .el-radio__label {
  color: white !important;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #f7d179 !important;
  border-color: #f7d179 !important;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #f7d179 !important;
}
.searchBarBtn {
  margin-top: 15px;
  justify-content: space-around;
}
.resetBtn,
.lookBtn {
  text-align: center;
  width: 122px;
  height: 38px;
  line-height: 36px;
  font-size: 12px;
}
.resetBtn {
  float: left;
}
.lookBtn {
  float: right;
  font-weight: bold;
}
.database-blank {
  height: 30px;
}
.database-list {
  flex: 1;
  background-color: rgba(46, 46, 46, 1);
  padding: 0 30px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  display: flex;
  flex-direction: column;
}
::v-deep .el-tag {
  background-color: transparent;
  border: none;
}
.searchBarBtn-database {
  width: 288px;
  margin-top: 66px;
}
.searchBarBtn-database-en {
  width: 306px
}
.is-act {
  color: rgb(0, 255, 0);
  font-size: 14px;
}
.edit-disabled {
  opacity: 0.4;
}
.plsc-btn-database {
  position: absolute;
  right: 12px;
  top: 17px;
  width: 130px;
  cursor: pointer;
}
.plsc-btn-database-en {
  width: 210px;
}
.list-page {
  margin-top: 30px;
}
</style>

<style>
.create-database .el-form-item__label {
  text-align: left !important;
  color: #FFF!important;
  font-weight: bold!important;
  font-size: 12px!important;
}
.create-database .el-input__inner {
  border-color: #b4b4b4 !important;
  border-radius: 5px !important;
}
.create-database .el-radio__label {
  font-size: 12px!important;
}
.sjk-radio .el-radio__input .el-radio__inner {
  width: 16px!important;
  height: 16px!important;
  background-image: url('@/assets/images/radio.png')!important;
  background-size: cover!important;
  border: none!important;
  background-color: transparent!important;
}
.sjk-radio .el-radio__input.is-checked .el-radio__inner {
  width: 16px!important;
  height: 16px!important;
  background-image: url('@/assets/images/radio2.png')!important;
  background-size: cover!important;
  border: none!important;
  background-color: transparent!important;
}
.sjk-radio .el-radio__input.is-checked .el-radio__inner::after {
  display: none;
}
</style>
